import React, { useState } from "react";
import axios from "axios";


const useLibrary = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const mainApi = '/koha/library'
    const [data, setData] = useState([])

    const getLibraryData = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const postLibraryData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchLibraryData = (data) => {
        
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteLibraryData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        LibraryData: data,
        getLibraryData,
        postLibraryData,
        patchLibraryData,
        deleteLibraryData,
    }
}
export { useLibrary }
